// extracted by mini-css-extract-plugin
export default {"registerPage":"Register_registerPage__MtQcQ","helpText":"Register_helpText__5PVPd","textButton":"Register_textButton__uzkfp","registerButton":"Register_registerButton__NvE3B"};